import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Copyright from "../dashboard/Copyright";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import swal from "sweetalert";
import LoadingOverlay from 'react-loading-overlay';
import {authHeader} from "../auth/authHeader";
import {authenticationService} from "../auth/authenticationService";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%'
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    form: {
        margin: 11
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

let books =[];

export default function CodeExchange() {
    const classes = useStyles();
    const [codeNumber, setCodeNumber] = React.useState("");
    const [isActive, setisActive] = React.useState(false);

    const handleTextFieldCodeNumberChange = (event) => {
        setCodeNumber(event.target.value);
    }

    const handleSubmit = () => {
        setisActive(true);
        //GenerateCodes
        axios
            .put(
                process.env.REACT_APP_BACKEND_API_URL + "/api/exchangeCode",
                {
                    codeToExchange: codeNumber,
                    userId: authenticationService.currentUserValue.id
                },
                {
                    headers: authHeader()
                }
            ).then(resp => {
            if (resp.data === "success") {
                setisActive(false);
                swal("¡Exito!", "Se ha canjeado tu código exitosamente", "success");
            } else {
                setisActive(false);
                swal("Oops!", "Ha ocurrido un error", "error");
            }
        }).catch(err => {
            setisActive(false);
            if (err.response.status === 401) {
                window.history.go("/");
            }
            console.log(err);
            swal("Oops!", "Ha ocurrido un error", "error");
        });
    }

    return (
        <div className={classes.root}>
            <LoadingOverlay
                active={isActive}
                spinner
                text='Ejecutando... Puede tomar unos segundos'
            >
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        <FormControl className={classes.formControl}>
                            <TextField id="codeNumber"
                                       label="Código"
                                       variant="outlined"
                                       type="text"
                                       margin="dense"
                                       onChange={handleTextFieldCodeNumberChange}
                                       required
                            />
                            <Button onClick={handleSubmit} variant="contained" color="primary">Canjear</Button>
                        </FormControl>
                        <Box pt={4}>
                            <Copyright/>
                        </Box>
                    </Container>
                </main>
            </LoadingOverlay>
        </div>
    );
}
